module.exports = __webpack_public_path__ + "img/c06_unitstartechspearmanchampion_Normal_ua.4441b024.webp";